/**
 * Implementation of IFloodgateStringProvider for Web SDK
 */
import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
import * as UIStrings from "./../UIStrings/UIStrings";
import * as Configuration from "./../Configuration/Configuration";
/* tslint:disable:max-line-length */
export default class FloodgateStringProvider {
  loadStringResource(stringId) {
    let uiStrings = UIStrings.getUIStrings();
    switch (stringId) {
      case 5 /* Nps11RatingValue0 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value0;
      case 6 /* Nps11RatingValue1 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value1;
      case 7 /* Nps11RatingValue2 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value2;
      case 8 /* Nps11RatingValue3 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value3;
      case 9 /* Nps11RatingValue4 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value4;
      case 10 /* Nps11RatingValue5 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value5;
      case 11 /* Nps11RatingValue6 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value6;
      case 12 /* Nps11RatingValue7 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value7;
      case 13 /* Nps11RatingValue8 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value8;
      case 14 /* Nps11RatingValue9 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value9;
      case 15 /* Nps11RatingValue10 */:
        return uiStrings.Floodgate.Nps.Rating.Points11Value10;
      case 16 /* Nps5RatingValue1 */:
        return uiStrings.Floodgate.Nps.Rating.Points5Value1;
      case 17 /* Nps5RatingValue2 */:
        return uiStrings.Floodgate.Nps.Rating.Points5Value2;
      case 18 /* Nps5RatingValue3 */:
        return uiStrings.Floodgate.Nps.Rating.Points5Value3;
      case 19 /* Nps5RatingValue4 */:
        return uiStrings.Floodgate.Nps.Rating.Points5Value4;
      case 20 /* Nps5RatingValue5 */:
        return uiStrings.Floodgate.Nps.Rating.Points5Value5;
      case 4 /* NpsRatingQuestion */:
        return uiStrings.Floodgate.Nps.Rating.Question;
      case 21 /* NpsCommentQuestion */:
        return uiStrings.Floodgate.Nps.Comment.Question;
      case 3 /* NpsPromptNotNowLabel */:
        return uiStrings.Floodgate.Nps.Prompt.No;
      case 1 /* NpsPromptQuestion */:
        return uiStrings.Floodgate.Nps.Prompt.Question;
      case 0 /* NpsPromptTitle */:
        return uiStrings.Floodgate.Nps.Prompt.Title;
      case 2 /* NpsPromptYesLabel */:
        return uiStrings.Floodgate.Nps.Prompt.Yes;
      default:
        return "";
    }
  }
  getCustomString(str) {
    return Configuration.get().getFloodgateInitOptions().uIStringGetter(str);
  }
}